import { FC } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@radix-ui/react-tooltip';

import IconNewPage from '@/assets/svg/icon-img-new-page.svg?react';
import IconImageRotateDown from '@/assets/svg/icon-img-rotate-down.svg?react';
import IconImageRotateUp from '@/assets/svg/icon-img-rotate-up.svg?react';
import IconZoomIn from '@/assets/svg/icon-img-zoom-in.svg?react';
import IconZoomOut from '@/assets/svg/icon-img-zoom-out.svg?react';

interface ImageControlsProps {
  onRotate: (direction: 'up' | 'down') => void;
  onZoom: (direction: 'in' | 'out') => void;
  imageOnNewPage: () => void;
}

const ImageControls: FC<ImageControlsProps> = ({
  onRotate,
  onZoom,
  imageOnNewPage,
}) => (
  <div className="absolute bottom-[-60px] left-1/2 flex h-[50px] w-[300px] -translate-x-1/2 items-center justify-center gap-14 rounded-md bg-[#002C4180] p-2 backdrop-blur-sm sm:bottom-[28px]">
    <div className="flex items-center">
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="rounded-sm p-2 text-white hover:bg-white/20"
            onClick={() => onRotate('up')}
          >
            <IconImageRotateUp className="h-5 w-5 fill-white" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="rounded-sm bg-white p-2 text-primary">
          <p>Повернути за годинниковою стрілкою</p>
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="rounded-sm p-2 text-white hover:bg-white/20"
            onClick={() => onRotate('down')}
          >
            <IconImageRotateDown className="h-5 w-5" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="rounded-sm bg-white p-2 text-primary">
          <p>Повернути проти годинникової стрілки</p>
        </TooltipContent>
      </Tooltip>
    </div>
    <div className="flex items-center">
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="rounded-sm p-2 text-white hover:bg-white/20"
            onClick={() => onZoom('in')}
          >
            <IconZoomIn className="h-5 w-5" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="rounded-sm bg-white p-2 text-primary">
          <p>Збільшити</p>
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="rounded-sm p-2 text-white hover:bg-white/20"
            onClick={() => onZoom('out')}
          >
            <IconZoomOut className="h-5 w-5" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="rounded-sm bg-white p-2 text-primary">
          <p>Зменшити</p>
        </TooltipContent>
      </Tooltip>
    </div>
    <div className="flex items-center">
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="rounded-sm p-2 text-white hover:bg-white/20"
            onClick={() => imageOnNewPage()}
          >
            <IconNewPage className="h-5 w-5" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="rounded-sm bg-white p-2 text-primary">
          <p>Відкрити в новій вкладці</p>
        </TooltipContent>
      </Tooltip>
    </div>
  </div>
);

export default ImageControls;
